// extracted by mini-css-extract-plugin
export default {"marker":"unreadMark_marker__nQ9rE","pulseMotion":"unreadMark_pulseMotion__nn8z7"};